import { Grid, Image } from 'semantic-ui-react'
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro'

import FormFlowFooter from '@/componentsV1/FormFlow/FormFlowFooter'
import { GridRowColumn, Text, Card, Icon } from '@/base'
import { makeGridConfig } from '@/componentsV1/BaseComponents/Grid'

const tqBigSpace = makeGridConfig([10, 14, 14], true)

const GoalSettingIntro = ({
  goBack,
  goToNextStep,
}: {
  goBack: (newScreen: string | null, replace?: boolean | undefined) => void
  goToNextStep: () => void
}) => {
  return (
    <Grid>
      <GridRowColumn {...tqBigSpace}>
        <Text as="display2" textAlign="center">
          Understanding Financial Goals
        </Text>
      </GridRowColumn>
      <GridRowColumn {...tqBigSpace}>
        <Text as="bodyLg">
          Effective financial planning starts with setting clear, measurable
          goals for income, expenses, and profit. This exercise will guide you
          through establishing these targets for the current year.
        </Text>
      </GridRowColumn>
      <GridRowColumn
        {...tqBigSpace}
        columnStyle={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
        verticalAlign="middle"
      >
        <Card type="section" style={{ margin: 0, width: '47%' }}>
          <Image
            src="https://heard-images.s3.amazonaws.com/assets/coins-stack-arrow.svg"
            style={{ width: 80, height: 80, backgroundColor: 'transparent' }}
          />
          <br />
          <Text as="h2">Income</Text>
          <br />
          <Text as="bodySm" color="darkGray">
            This includes session fees, group therapy, workshops, insurance
            reimbursements, and any specialized services you offer.
          </Text>
        </Card>
        <Icon
          icon={regular('minus')}
          size="2x"
          style={{ marginRight: 24, marginLeft: 24, width: '6%' }}
        />
        <Card type="section" style={{ margin: 0, width: '47%' }}>
          <Image
            src="https://heard-images.s3.amazonaws.com/assets/split-money.svg"
            style={{ width: 80, height: 80, backgroundColor: 'transparent' }}
          />
          <br />
          <Text as="h2">Expenses</Text>
          <br />
          <Text as="bodySm" color="darkGray">
            The costs of running your therapy practice.
          </Text>
        </Card>
      </GridRowColumn>
      <GridRowColumn {...tqBigSpace} centerContent>
        <Icon icon={regular('equals')} size="2x" />
      </GridRowColumn>
      <GridRowColumn {...tqBigSpace}>
        <Card type="section" style={{ display: 'flex', flexDirection: 'row' }}>
          <Image
            src="https://heard-images.s3.amazonaws.com/assets/coins-stack-sparkle.svg"
            style={{ width: 80, height: 80, backgroundColor: 'transparent' }}
          />
          <div style={{ marginLeft: 24 }}>
            <Text as="h2">Profit</Text>
            <br />
            <Text as="bodySm" color="darkGray">
              This is your personal income before taxes. It funds your living
              expenses, retirement contributions, and other financial goals.
            </Text>
          </div>
        </Card>
      </GridRowColumn>
      <FormFlowFooter
        onBack={() => goBack(null)}
        onForward={goToNextStep}
        continueButtonText="Next"
      />
    </Grid>
  )
}

export default GoalSettingIntro
